import React, { useState, useEffect, useRef } from 'react';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ── SMART DATE PICKER ─────────────────────────────────────────────────────────
function SmartDatePicker({ label, value, onChange, placeholder = 'dd/mm/yyyy', darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(() => value ? new Date(value).getFullYear() : new Date().getFullYear());
  const [viewMonth, setViewMonth] = useState(() => value ? new Date(value).getMonth() : new Date().getMonth());
  const [mode, setMode] = useState('day');
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const DAYS = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  const today = new Date(); today.setHours(0,0,0,0);
  const selected = value ? new Date(value + 'T00:00:00') : null;
  const getDays = () => {
    const first = new Date(viewYear, viewMonth, 1).getDay();
    const total = new Date(viewYear, viewMonth + 1, 0).getDate();
    const prev = new Date(viewYear, viewMonth, 0).getDate();
    const cells = [];
    for (let i = first - 1; i >= 0; i--) cells.push({ d: prev - i, curr: false });
    for (let d = 1; d <= total; d++) cells.push({ d, curr: true });
    while (cells.length % 7 !== 0) cells.push({ d: cells.length - first - total + 1, curr: false });
    return cells;
  };
  const selectDay = (d) => {
    const m = String(viewMonth + 1).padStart(2,'0'), dd = String(d).padStart(2,'0');
    onChange(`${viewYear}-${m}-${dd}`); setOpen(false);
  };
  const yearRange = Array.from({ length: 12 }, (_, i) => viewYear - 5 + i);
  const displayVal = value ? new Date(value + 'T00:00:00').toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '';

  return (
    <div style={{ position:'relative' }} ref={ref}>
      {label && <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>{label}</label>}
      <button type="button" onClick={() => { setOpen(o => !o); setMode('day'); }}
        style={{ width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, textAlign:'left', display:'flex', alignItems:'center', justifyContent:'space-between', background:T.inputBg, cursor:'pointer', outline:'none', boxSizing:'border-box', color: displayVal ? T.text : T.text3 }}>
        <span>{displayVal || placeholder}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
      </button>
      {open && (
        <div style={{ position:'absolute', top:'calc(100% + 4px)', left:0, background:T.bg2, border:`1px solid ${T.border2}`, borderRadius:12, boxShadow: darkMode?'0 12px 40px rgba(0,0,0,0.5)':'0 12px 40px rgba(15,31,69,0.12)', zIndex:9999, width:288, overflow:'hidden' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', borderBottom:`1px solid ${T.border}` }}>
            <button type="button" onClick={() => { if(mode==='day') setViewMonth(m => { if(m===0){setViewYear(y=>y-1);return 11;} return m-1; }); else if(mode==='year') setViewYear(y=>y-12); }}
              style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:T.text2 }}
              onMouseEnter={e=>e.currentTarget.style.background=T.bg3} onMouseLeave={e=>e.currentTarget.style.background='none'}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div style={{ display:'flex', gap:4 }}>
              <button type="button" onClick={() => setMode(m => m==='month'?'day':'month')}
                style={{ padding:'4px 8px', borderRadius:8, border:'none', background:'none', fontSize:13, fontWeight:700, color:T.text, cursor:'pointer' }}
                onMouseEnter={e=>e.currentTarget.style.background=T.bg3} onMouseLeave={e=>e.currentTarget.style.background='none'}>{MONTHS[viewMonth]}</button>
              <button type="button" onClick={() => setMode(m => m==='year'?'day':'year')}
                style={{ padding:'4px 8px', borderRadius:8, border:'none', background:'none', fontSize:13, fontWeight:700, color:T.text, cursor:'pointer' }}
                onMouseEnter={e=>e.currentTarget.style.background=T.bg3} onMouseLeave={e=>e.currentTarget.style.background='none'}>{viewYear}</button>
            </div>
            <button type="button" onClick={() => { if(mode==='day') setViewMonth(m => { if(m===11){setViewYear(y=>y+1);return 0;} return m+1; }); else if(mode==='year') setViewYear(y=>y+12); }}
              style={{ width:28, height:28, borderRadius:8, border:'none', background:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:T.text2 }}
              onMouseEnter={e=>e.currentTarget.style.background=T.bg3} onMouseLeave={e=>e.currentTarget.style.background='none'}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
          {mode==='month' && (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:4, padding:12 }}>
              {MONTHS.map((m,i) => (
                <button key={m} type="button" onClick={() => { setViewMonth(i); setMode('day'); }}
                  style={{ padding:'8px 0', borderRadius:8, border:'none', fontSize:12, fontWeight:600, cursor:'pointer', background: viewMonth===i?'linear-gradient(135deg,#0f1f45,#1a3a6b)':'none', color: viewMonth===i?'#fff':T.text2 }}
                  onMouseEnter={e=>{ if(viewMonth!==i) e.currentTarget.style.background=T.bg3; }}
                  onMouseLeave={e=>{ if(viewMonth!==i) e.currentTarget.style.background='none'; }}>{m}</button>
              ))}
            </div>
          )}
          {mode==='year' && (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:4, padding:12 }}>
              {yearRange.map(y => (
                <button key={y} type="button" onClick={() => { setViewYear(y); setMode('day'); }}
                  style={{ padding:'8px 0', borderRadius:8, border:'none', fontSize:12, fontWeight:600, cursor:'pointer', background: viewYear===y?'linear-gradient(135deg,#0f1f45,#1a3a6b)':'none', color: viewYear===y?'#fff':T.text2 }}
                  onMouseEnter={e=>{ if(viewYear!==y) e.currentTarget.style.background=T.bg3; }}
                  onMouseLeave={e=>{ if(viewYear!==y) e.currentTarget.style.background='none'; }}>{y}</button>
              ))}
            </div>
          )}
          {mode==='day' && (
            <div style={{ padding:12 }}>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', marginBottom:4 }}>
                {DAYS.map(d => <div key={d} style={{ textAlign:'center', fontSize:11, fontWeight:600, color:T.text3, padding:'4px 0' }}>{d}</div>)}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)' }}>
                {getDays().map((cell,i) => {
                  const cd = new Date(viewYear, viewMonth, cell.d); cd.setHours(0,0,0,0);
                  const isSel = selected && cell.curr && cd.getTime()===selected.getTime();
                  const isToday = cell.curr && cd.getTime()===today.getTime();
                  return (
                    <button key={i} type="button" onClick={() => cell.curr && selectDay(cell.d)}
                      style={{ height:32, width:'100%', borderRadius:8, border: isToday&&!isSel?`1px solid #3b82f6`:'none',
                        background: isSel?'linear-gradient(135deg,#0f1f45,#1a3a6b)':'none',
                        color: !cell.curr?T.text3:isSel?'#fff':isToday?'#3b82f6':T.text2,
                        fontSize:12, fontWeight: isSel||isToday?700:400, cursor: cell.curr?'pointer':'default' }}
                      onMouseEnter={e=>{ if(cell.curr&&!isSel) e.currentTarget.style.background=T.bg3; }}
                      onMouseLeave={e=>{ if(!isSel) e.currentTarget.style.background='none'; }}>{cell.d}
                    </button>
                  );
                })}
              </div>
              {value && (
                <button type="button" onClick={() => { onChange(''); setOpen(false); }}
                  style={{ width:'100%', marginTop:8, padding:'6px 0', fontSize:12, color:T.text3, background:'none', border:'none', cursor:'pointer', borderRadius:8 }}
                  onMouseEnter={e=>{ e.currentTarget.style.color='#ef4444'; e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.1)':'#fef2f2'; }}
                  onMouseLeave={e=>{ e.currentTarget.style.color=T.text3; e.currentTarget.style.background='none'; }}>
                  Clear date
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── RENEWAL TYPE DROPDOWN ─────────────────────────────────────────────────────
// Same look/behaviour as the Client Type dropdown in the Clients module: a
// styled trigger + popup list with hover-highlighted options, plus an inline
// "+ Add new type" row so a firm-specific renewal type (e.g. "Class 3 DSC |
// 2 Years Validity") can be created without leaving the form.
function RenewalTypeDropdown({ types, value, onChange, onCreate, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState('');
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setAdding(false); } };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const selected = types.find(t => t.name === value);

  const submitNew = async () => {
    const name = newName.trim();
    if (!name || busy) return;
    setBusy(true);
    try {
      const created = await onCreate(name);
      if (created?.name) onChange(created.name);
      setNewName(''); setAdding(false); setOpen(false);
    } finally { setBusy(false); }
  };

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <button type="button" onClick={() => setOpen(o => !o)}
        style={{
          width:'100%', border:`1px solid ${open ? '#3b82f6' : T.inputBorder}`, borderRadius:9,
          padding:'9px 12px', fontSize:13, textAlign:'left', display:'flex', alignItems:'center',
          justifyContent:'space-between', background:T.inputBg, cursor:'pointer', minHeight:38,
          transition:'border-color 0.15s', boxSizing:'border-box',
        }}>
        <span style={{ color: selected ? T.text : T.text3, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
          {selected ? selected.name : 'Select type...'}
        </span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="2"
          style={{ flexShrink:0, marginLeft:6, transform: open ? 'rotate(180deg)' : 'none', transition:'transform 0.2s' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {open && (
        <div style={{
          position:'absolute', top:'calc(100% + 6px)', left:0, right:0, background:T.bg2,
          border:`1px solid ${T.border2}`, borderRadius:12, zIndex:9999, overflow:'hidden',
          boxShadow: darkMode ? '0 12px 40px rgba(0,0,0,0.5)' : '0 12px 40px rgba(15,31,69,0.14)',
        }}>
          <div style={{ maxHeight:210, overflowY:'auto', padding:5 }}>
            {types.map(t => {
              const sel = t.name === value;
              return (
                <button key={t.id} type="button" onClick={() => { onChange(t.name); setOpen(false); }}
                  style={{ width:'100%', display:'flex', alignItems:'center', gap:8, padding:'8px 10px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, color:T.text, textAlign:'left', fontWeight: sel ? 700 : 500, background: sel ? (darkMode?'rgba(59,130,246,0.12)':'#eff6ff') : 'transparent', transition:'background 0.12s' }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = T.bg3; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = 'transparent'; }}>
                  <span style={{ flex:1, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{t.name}</span>
                  {sel && <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                </button>
              );
            })}
            {types.length === 0 && <p style={{ fontSize:12, color:T.text3, padding:'10px' }}>No renewal types configured</p>}
          </div>

          <div style={{ borderTop:`1px solid ${T.border}`, padding:5 }}>
            {adding ? (
              <div style={{ display:'flex', gap:6, alignItems:'center', padding:'2px' }}>
                <input autoFocus type="text" value={newName} placeholder="e.g. Class 3 DSC | 2 Years Validity"
                  onChange={e => setNewName(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); submitNew(); } if (e.key === 'Escape') { setAdding(false); setNewName(''); } }}
                  style={{ flex:1, border:`1px solid ${T.inputBorder}`, borderRadius:8, padding:'7px 10px', fontSize:12, outline:'none', background:T.bg3, color:T.text, boxSizing:'border-box' }} />
                <button type="button" onClick={submitNew} disabled={busy || !newName.trim()}
                  style={{ padding:'7px 12px', borderRadius:8, border:'none', background:'#0f1f45', color:'#fff', fontSize:12, fontWeight:600, cursor: busy||!newName.trim() ? 'default' : 'pointer', opacity: busy||!newName.trim() ? 0.5 : 1, flexShrink:0 }}>
                  {busy ? '…' : 'Add'}
                </button>
              </div>
            ) : (
              <button type="button" onClick={() => setAdding(true)}
                style={{ width:'100%', display:'flex', alignItems:'center', gap:8, padding:'8px 10px', borderRadius:8, border:'none', background:'transparent', cursor:'pointer', fontSize:12.5, fontWeight:600, color:'#3b82f6', textAlign:'left' }}
                onMouseEnter={e => e.currentTarget.style.background = darkMode?'rgba(59,130,246,0.1)':'#eff6ff'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Add new type
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── ADD / EDIT RENEWAL MODAL ──────────────────────────────────────────────────
function RenewalFormModal({ token, editRenewal, preSelectedClient, renewalTypes, onRenewalTypeCreated, onClose, onSuccess, darkMode = false, T: theme }) {
  const T = theme || { bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBg:'#fff', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const [clients, setClients] = useState([]);
  const [persons, setPersons] = useState([]);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    client_id: preSelectedClient?.id || editRenewal?.client_id || '',
    renewal_type: editRenewal?.renewal_type || '',
    issue_date: editRenewal?.issue_date ? editRenewal.issue_date.split('T')[0] : '',
    expiry_date: editRenewal?.expiry_date ? editRenewal.expiry_date.split('T')[0] : '',
    alert_before_days: editRenewal?.alert_before_days || 30,
    notes: editRenewal?.notes || '',
    status: editRenewal?.status || 'active',
    person_id: editRenewal?.person_id || '',
  });

  const is = { width:'100%', border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'9px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, boxSizing:'border-box' };
  const SL = ({ children, req }) => <label style={{ display:'block', fontSize:11, fontWeight:600, color:T.text3, marginBottom:5, textTransform:'uppercase', letterSpacing:'0.05em' }}>{children}{req && <span style={{ color:'#ef4444', marginLeft:3 }}>*</span>}</label>;

  useEffect(() => {
    fetch(`${BASE}/api/clients`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    }).then(r => r.json()).then(d => setClients(Array.isArray(d) ? d : [])).catch(() => {});
    fetch(`${BASE}/api/persons`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    }).then(r => r.json()).then(d => setPersons(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  // Only people actually linked to the selected company — a DSC/renewal
  // belongs to one of that company's directors/partners, not any random person.
  const clientId = preSelectedClient?.id || form.client_id;
  const personsForClient = clientId
    ? persons.filter(p => (p.linked_clients || []).some(lc => String(lc.client_id) === String(clientId)))
    : [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const url = editRenewal
        ? `${BASE}/api/clients/${form.client_id}/renewals/${editRenewal.id}`
        : `${BASE}/api/clients/${form.client_id}/renewals`;
      const method = editRenewal ? 'PUT' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify(form)
      });
      if (res.ok) { onSuccess(); onClose(); }
      else { const d = await res.json(); alert(d.message || 'Error saving renewal'); }
    } catch { alert('Server error'); }
    finally { setSaving(false); }
  };

  const selectedClient = preSelectedClient || clients.find(c => String(c.id) === String(form.client_id));

  const handleCreateType = async (name) => {
    const res = await fetch(`${BASE}/api/renewal-types`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify({ name })
    });
    const created = await res.json().catch(() => null);
    if (res.ok && created?.name) { onRenewalTypeCreated?.(created); return created; }
    alert(created?.message || 'Could not create renewal type');
    return null;
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:60, padding:16 }}>
      <div style={{ background:T.bg2, borderRadius:20, width:'100%', maxWidth:560, boxShadow: darkMode?'0 24px 60px rgba(0,0,0,0.6)':'0 24px 60px rgba(15,31,69,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>

        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 24px', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', flexShrink:0 }}>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            <div style={{ width:40, height:40, borderRadius:10, background:'rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
            <div>
              <h2 style={{ fontSize:15, fontWeight:700, color:'#fff', margin:0 }}>{editRenewal ? 'Edit Renewal' : 'Add Renewal'}</h2>
              {selectedClient && <p style={{ fontSize:12, color:'rgba(255,255,255,0.6)', margin:'3px 0 0' }}>{selectedClient.client_name}</p>}
            </div>
          </div>
          <button onClick={onClose}
            style={{ width:34, height:34, borderRadius:9, border:'none', background:'rgba(255,255,255,0.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.2)'}
            onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.1)'}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} style={{ padding:24, display:'flex', flexDirection:'column', gap:16, background:T.bg3, overflowY:'auto', scrollbarWidth:'none' }}>

          {/* Client selector */}
          {!preSelectedClient && (
            <div>
              <SL req>Client</SL>
              <select required value={form.client_id} onChange={e=>setForm(f=>({...f,client_id:e.target.value}))} style={is}>
                <option value="">Select client...</option>
                {clients.map(c=><option key={c.id} value={c.id}>{c.client_name} — {c.file_number}</option>)}
              </select>
            </div>
          )}

          {/* Pre-selected client chip */}
          {preSelectedClient && (
            <div style={{ background: darkMode?'rgba(59,130,246,0.1)':'#eff6ff', border:`1px solid ${darkMode?'rgba(59,130,246,0.2)':'#bfdbfe'}`, borderRadius:12, padding:'10px 14px', display:'flex', alignItems:'center', gap:12 }}>
              <div style={{ width:36, height:36, borderRadius:9, background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:14, fontWeight:700, flexShrink:0 }}>
                {preSelectedClient.client_name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{preSelectedClient.client_name}</p>
                <p style={{ fontSize:11, color:T.text3, margin:'2px 0 0' }}>{preSelectedClient.file_number}</p>
              </div>
            </div>
          )}

          {/* Renewal Type */}
          <div>
            <SL req>Renewal Type</SL>
            <RenewalTypeDropdown types={renewalTypes} value={form.renewal_type} onChange={v=>setForm(f=>({...f,renewal_type:v}))} onCreate={handleCreateType} darkMode={darkMode} T={T} />
          </div>

          {/* Person (optional) — e.g. which director's DSC this renewal tracks */}
          <div>
            <SL>Person (for DSC / individual-held renewals)</SL>
            <select value={form.person_id} onChange={e=>setForm(f=>({...f,person_id:e.target.value}))} style={is} disabled={!clientId}>
              <option value="">{clientId ? 'None — this is a company-level renewal' : 'Select a client first'}</option>
              {personsForClient.map(p=><option key={p.id} value={p.id}>{p.full_name}{p.din?` (DIN: ${p.din})`:''}</option>)}
            </select>
            {clientId && personsForClient.length===0 && (
              <p style={{ fontSize:11, color:T.text3, marginTop:4 }}>No people linked to this client yet — link them from the People module first.</p>
            )}
            {form.person_id && /dsc/i.test(form.renewal_type) && (
              <p style={{ fontSize:11, color:T.text3, marginTop:4 }}>Saving this will also update this person's DSC Expiry in the People module.</p>
            )}
          </div>

          {/* Dates row */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            <SmartDatePicker label="Issue Date" value={form.issue_date} onChange={v=>setForm(f=>({...f,issue_date:v}))} darkMode={darkMode} T={T} />
            <SmartDatePicker label="Expiry Date *" value={form.expiry_date} onChange={v=>setForm(f=>({...f,expiry_date:v}))} darkMode={darkMode} T={T} />
          </div>

          {/* Alert + Status row */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            <div>
              <SL>Alert Before (days)</SL>
              <input type="number" min="1" max="365" value={form.alert_before_days}
                onChange={e=>setForm(f=>({...f,alert_before_days:e.target.value}))} style={is} />
            </div>
            <div>
              <SL>Status</SL>
              <select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={is}>
                <option value="active">Active</option>
                <option value="renewed">Renewed</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>
          </div>

          {/* Notes */}
          <div>
            <SL>Notes</SL>
            <textarea rows="2" placeholder="Any additional notes..." value={form.notes}
              onChange={e=>setForm(f=>({...f,notes:e.target.value}))}
              style={{ ...is, resize:'none', lineHeight:1.5 }} />
          </div>

          {/* Footer buttons */}
          <div style={{ display:'flex', gap:10, paddingTop:4 }}>
            <button type="button" onClick={onClose}
              style={{ padding:'10px 20px', borderRadius:9, border:`1px solid ${T.border2}`, background:T.bg2, color:T.text2, fontSize:13, fontWeight:500, cursor:'pointer' }}
              onMouseEnter={e=>e.currentTarget.style.background=T.bg3}
              onMouseLeave={e=>e.currentTarget.style.background=T.bg2}>
              Cancel
            </button>
            <button type="submit" disabled={saving || !form.expiry_date || !form.renewal_type || (!preSelectedClient && !form.client_id)}
              style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:8, padding:'10px 24px', borderRadius:9, border:'none',
                background: saving||!form.expiry_date||!form.renewal_type||(!preSelectedClient&&!form.client_id)?'#94a3b8':'linear-gradient(135deg,#0f1f45,#1a3a6b)',
                color:'#fff', fontSize:13, fontWeight:600, cursor: saving||!form.expiry_date||!form.renewal_type||(!preSelectedClient&&!form.client_id)?'not-allowed':'pointer',
                boxShadow: saving||!form.expiry_date||!form.renewal_type||(!preSelectedClient&&!form.client_id)?'none':'0 4px 12px rgba(15,31,69,0.3)' }}>
              {saving && <span style={{ width:13, height:13, border:'2px solid #fff', borderTopColor:'transparent', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>}
              {saving ? 'Saving...' : editRenewal ? 'Save Changes' : 'Add Renewal'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ── MAIN RENEWALS PAGE ────────────────────────────────────────────────────────
function Renewals({ darkMode = false, T: theme }) {
  const T = theme || { bg:'#f4f7ff', bg2:'#fff', bg3:'#f8faff', border:'#e8edf5', border2:'#e2e8f0', text:'#0f1f45', text2:'#4a5568', text3:'#94a3b8', cardBg:'#fff', cardBorder:'#f1f5f9', inputBg:'#fff', inputBorder:'#e2e8f0' };
  const [renewals, setRenewals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('All Types');
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editRenewal, setEditRenewal] = useState(null);
  const [preSelectedClient, setPreSelectedClient] = useState(null);
  const [renewalTypes, setRenewalTypes] = useState([]);
  const token = localStorage.getItem('token');

  const fetchRenewals = async () => {
    try {
      const res = await fetch(`${BASE}/api/renewals/all`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setRenewals(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchRenewals();
    fetch(`${BASE}/api/renewal-types`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()).then(d => setRenewalTypes(Array.isArray(d) ? d : [])).catch(() => setRenewalTypes([]));

    const handler = (e) => {
      if (e.detail?.page === 'renewals') {
        if (e.detail?.clientId) {
          fetch(`${BASE}/api/clients/${e.detail.clientId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(r => r.json()).then(client => {
            setPreSelectedClient(client);
            setShowForm(true);
          }).catch(() => setShowForm(true));
        } else {
          setShowForm(true);
        }
      }
    };
    window.addEventListener('navigateTo', handler);
    return () => window.removeEventListener('navigateTo', handler);
  }, []);

  const daysUntilExpiry = (date) => {
    const diff = new Date(date) - new Date();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const expiryStatus = (date) => {
    const days = daysUntilExpiry(date);
    if (days < 0)   return { label: 'Expired',       color:'#dc2626', bg: darkMode?'rgba(220,38,38,0.12)':'#fef2f2',   border: darkMode?'rgba(220,38,38,0.25)':'#fecaca' };
    if (days <= 30)  return { label: `${days}d left`, color:'#ea580c', bg: darkMode?'rgba(249,115,22,0.12)':'#fff7ed',   border: darkMode?'rgba(249,115,22,0.25)':'#fed7aa' };
    if (days <= 90)  return { label: `${days}d left`, color:'#d97706', bg: darkMode?'rgba(245,158,11,0.12)':'#fffbeb',   border: darkMode?'rgba(245,158,11,0.25)':'#fde68a' };
    return            { label: `${days}d left`, color:'#16a34a', bg: darkMode?'rgba(22,163,74,0.12)':'#f0fdf4',    border: darkMode?'rgba(22,163,74,0.25)':'#bbf7d0' };
  };

  const rowBg = (days) => {
    if (days < 0)   return darkMode ? 'rgba(220,38,38,0.06)'   : 'rgba(254,242,242,0.6)';
    if (days <= 30) return darkMode ? 'rgba(249,115,22,0.06)'  : 'rgba(255,247,237,0.6)';
    return 'transparent';
  };

  const handleDelete = async (r) => {
    if (!window.confirm(`Delete renewal "${r.renewal_type}" for ${r.client_name}?`)) return;
    await fetch(`${BASE}/api/clients/${r.client_id}/renewals/${r.id}`, {
      method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
    }).catch(console.error);
    fetchRenewals();
  };

  const filtered = renewals
    .filter(r => {
      const q = searchTerm.toLowerCase();
      const matchSearch = !searchTerm || r.client_name?.toLowerCase().includes(q) || r.renewal_type?.toLowerCase().includes(q) || r.file_number?.toLowerCase().includes(q) || r.person_name?.toLowerCase().includes(q);
      const matchType = filterType === 'All Types' || r.renewal_type === filterType;
      const days = daysUntilExpiry(r.expiry_date);
      const matchStatus =
        filterStatus === 'all' ||
        (filterStatus === 'expired'  && days < 0) ||
        (filterStatus === 'critical' && days >= 0 && days <= 30) ||
        (filterStatus === 'upcoming' && days > 30 && days <= 90) ||
        (filterStatus === 'active'   && days > 90);
      return matchSearch && matchType && matchStatus;
    })
    .sort((a, b) => new Date(a.expiry_date) - new Date(b.expiry_date));

  const stats = {
    expired:  renewals.filter(r => daysUntilExpiry(r.expiry_date) < 0).length,
    critical: renewals.filter(r => { const d = daysUntilExpiry(r.expiry_date); return d >= 0 && d <= 30; }).length,
    upcoming: renewals.filter(r => { const d = daysUntilExpiry(r.expiry_date); return d > 30 && d <= 90; }).length,
    active:   renewals.filter(r => daysUntilExpiry(r.expiry_date) > 90).length,
  };

  const openEdit = (r) => {
    setEditRenewal(r);
    setPreSelectedClient({ id: r.client_id, client_name: r.client_name, file_number: r.file_number });
    setShowForm(true);
  };

  const STAT_CARDS = [
    { label:'Expired',             value: stats.expired,  color:'#dc2626', glow:'rgba(220,38,38,0.12)',  status:'expired'  },
    { label:'Critical (≤30 days)', value: stats.critical, color:'#ea580c', glow:'rgba(249,115,22,0.12)', status:'critical' },
    { label:'Upcoming (≤90 days)', value: stats.upcoming, color:'#d97706', glow:'rgba(245,158,11,0.12)', status:'upcoming' },
    { label:'Active',              value: stats.active,   color:'#16a34a', glow:'rgba(22,163,74,0.12)',  status:'active'   },
  ];

  return (
    <div style={{
      minHeight:'100vh', padding:24,
      background: darkMode
        ? 'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.07) 0%,transparent 60%),#0a0f1e'
        : 'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.05) 0%,transparent 50%),#f4f7ff',
    }}>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div>
          <p style={{ fontSize:14, color:T.text3, margin:0 }}>Track all client renewals and expiry dates across your firm</p>
        </div>
        <button onClick={() => { setEditRenewal(null); setPreSelectedClient(null); setShowForm(true); }}
          style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 20px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#0f1f45,#1a3a6b)', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', boxShadow:'0 4px 12px rgba(15,31,69,0.3)' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Renewal
        </button>
      </div>

      {/* Stats Cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginBottom:20 }}>
        {STAT_CARDS.map(stat => {
          const active = filterStatus === stat.status;
          return (
            <button key={stat.label}
              onClick={() => setFilterStatus(filterStatus === stat.status ? 'all' : stat.status)}
              style={{
                borderRadius:14, padding:'16px 20px', textAlign:'left', cursor:'pointer', transition:'all 0.15s',
                background:T.bg2, border:`2px solid ${active ? stat.color : T.cardBorder}`,
                boxShadow: active ? `0 4px 20px ${stat.glow}` : `0 2px 8px ${stat.glow}`,
                position:'relative', overflow:'hidden',
              }}>
              <div style={{ position:'absolute', top:-16, right:-16, width:56, height:56, borderRadius:'50%', background:stat.glow, filter:'blur(12px)' }}/>
              <p style={{ fontSize:26, fontWeight:800, color:stat.color, margin:0 }}>{stat.value}</p>
              <p style={{ fontSize:11, color: active?stat.color:T.text3, marginTop:5, fontWeight: active?700:400 }}>{stat.label}</p>
            </button>
          );
        })}
      </div>

      {/* Filters */}
      <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:14, padding:14, marginBottom:16, display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', boxShadow: darkMode?'0 2px 12px rgba(0,0,0,0.2)':'0 1px 6px rgba(15,31,69,0.05)' }}>
        <input type="text" placeholder="Search client name, file no., renewal type..."
          value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
          style={{ flex:1, minWidth:220, border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'8px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text }} />
        <select value={filterType} onChange={e => setFilterType(e.target.value)}
          style={{ border:`1px solid ${T.inputBorder}`, borderRadius:9, padding:'8px 12px', fontSize:13, outline:'none', background:T.inputBg, color:T.text, minWidth:180 }}>
          <option value="All Types">All Types</option>
          {renewalTypes.map(t=><option key={t.id} value={t.name}>{t.name}</option>)}
        </select>
        {(filterType !== 'All Types' || filterStatus !== 'all' || searchTerm) && (
          <button onClick={() => { setFilterStatus('all'); setFilterType('All Types'); setSearchTerm(''); }}
            style={{ padding:'8px 14px', borderRadius:9, border:`1px solid ${T.border2}`, background:'none', color:'#ef4444', fontSize:12, fontWeight:500, cursor:'pointer' }}>
            Clear
          </button>
        )}
        <p style={{ fontSize:12, color:T.text3, whiteSpace:'nowrap' }}>{filtered.length} found</p>
      </div>

      {/* Table */}
      <div style={{ background:T.bg2, border:`1px solid ${T.cardBorder}`, borderRadius:14, overflow:'hidden', boxShadow: darkMode?'0 4px 24px rgba(0,0,0,0.3)':'0 2px 12px rgba(15,31,69,0.06)' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead style={{ background:'linear-gradient(135deg,#0f1f45,#1a3a6b)' }}>
            <tr>
              {['Client','Renewal Type','Issue Date','Expiry Date','Alert','Notes','Status','Actions'].map(h => (
                <th key={h} style={{ padding:'11px 16px', textAlign:'left', fontSize:11, fontWeight:700, color:'#fff', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" style={{ padding:'48px 16px', textAlign:'center', color:T.text3, fontSize:13 }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                  <span style={{ width:16, height:16, border:`2px solid ${T.border2}`, borderTopColor:'#3b82f6', borderRadius:'50%', display:'inline-block', animation:'spin 0.6s linear infinite' }}/>
                  Loading renewals...
                </div>
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan="8" style={{ padding:'56px 16px', textAlign:'center' }}>
                <svg style={{ display:'block', margin:'0 auto 14px' }} width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={T.text3} strokeWidth="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <p style={{ fontSize:14, fontWeight:600, color:T.text2, margin:0 }}>No renewals found</p>
                <p style={{ fontSize:12, color:T.text3, marginTop:5 }}>Add renewals from Client Dashboard or click "+ Add Renewal"</p>
              </td></tr>
            ) : filtered.map((r, idx) => {
              const st = expiryStatus(r.expiry_date);
              const days = daysUntilExpiry(r.expiry_date);
              const bg = rowBg(days);
              return (
                <tr key={r.id} style={{ borderBottom:`1px solid ${T.border}`, background: bg || (darkMode&&idx%2!==0?T.bg3:'transparent'), transition:'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = darkMode?'#1e3a5f':'#f0f4ff'}
                  onMouseLeave={e => e.currentTarget.style.background = bg || (darkMode&&idx%2!==0?T.bg3:'transparent')}>
                  <td style={{ padding:'11px 16px' }}>
                    <p style={{ fontSize:13, fontWeight:600, color:T.text, margin:0 }}>{r.client_name}</p>
                    <p style={{ fontSize:11, color:T.text3, margin:'2px 0 0' }}>
                      {r.person_name ? `For: ${r.person_name}` : r.file_number}
                    </p>
                  </td>
                  <td style={{ padding:'11px 16px' }}>
                    <span style={{ fontSize:13, fontWeight:500, color:'#3b82f6' }}>{r.renewal_type}</span>
                  </td>
                  <td style={{ padding:'11px 16px', fontSize:12, color:T.text3, whiteSpace:'nowrap' }}>
                    {r.issue_date ? new Date(r.issue_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—'}
                  </td>
                  <td style={{ padding:'11px 16px', fontSize:13, fontWeight:600, color:T.text, whiteSpace:'nowrap' }}>
                    {new Date(r.expiry_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}
                  </td>
                  <td style={{ padding:'11px 16px', fontSize:12, color:T.text3 }}>{r.alert_before_days}d</td>
                  <td style={{ padding:'11px 16px', fontSize:12, color:T.text3, maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{r.notes || '—'}</td>
                  <td style={{ padding:'11px 16px' }}>
                    <span style={{ fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, color:st.color, background:st.bg, border:`1px solid ${st.border}`, whiteSpace:'nowrap' }}>
                      {st.label}
                    </span>
                  </td>
                  <td style={{ padding:'11px 16px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <button onClick={() => openEdit(r)} title="Edit"
                        style={{ width:30, height:30, borderRadius:8, border:'none', background:'none', color:T.text3, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>{e.currentTarget.style.background=T.bg3; e.currentTarget.style.color=T.text2;}}
                        onMouseLeave={e=>{e.currentTarget.style.background='none'; e.currentTarget.style.color=T.text3;}}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button onClick={() => handleDelete(r)} title="Delete"
                        style={{ width:30, height:30, borderRadius:8, border:'none', background:'none', color:'#ef4444', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                        onMouseEnter={e=>e.currentTarget.style.background=darkMode?'rgba(239,68,68,0.12)':'#fef2f2'}
                        onMouseLeave={e=>e.currentTarget.style.background='none'}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showForm && (
        <RenewalFormModal
          token={token}
          editRenewal={editRenewal}
          preSelectedClient={preSelectedClient}
          renewalTypes={renewalTypes}
          onRenewalTypeCreated={(created) => setRenewalTypes(prev => prev.some(t => t.id === created.id) ? prev : [...prev, created].sort((a,b) => a.name.localeCompare(b.name)))}
          onClose={() => { setShowForm(false); setEditRenewal(null); setPreSelectedClient(null); }}
          onSuccess={fetchRenewals}
          darkMode={darkMode}
          T={T}
        />
      )}
    </div>
  );
}

export default Renewals;